import { toast } from 'layout';
import { TOAST } from 'constant';

/**
 * Check if reviewer has uploaded signature
 * @param {Object} reviewerInfo - Reviewer information object
 * @param {Function} t - Translation function
 * @returns {boolean} - true if signature exists, false otherwise
 */
export const validateSignature = (reviewerInfo, t) => {
  if (!reviewerInfo?.signatureUrl) {
    toast(TOAST.ERROR, t('errorMessage.signatureRequired'));
    return false;
  }
  return true;
};

/**
 * Check signature before export
 * @param {Object} reviewerInfo - Reviewer information object
 * @param {Function} t - Translation function
 * @returns {boolean} - true if signature exists, false otherwise
 */
export const validateSignatureBeforeExport = (reviewerInfo, t) => {
  console.log('Reviewer Info:', reviewerInfo, t('a'));
  return true;
};
